/** @format */

import styled from 'styled-components';

export const SkeletonGalleryContent = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  background: var(--gray-200);
  animation: pulse-opacity 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

export const SkeletonTitle = styled.div`
  --clamped-width: clamp(18.5rem, 17.5192rem + 4.359vw, 22.75rem);
  color: transparent;
  max-width: 60%;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
  margin: 0;
  margin-top: 0;
  margin-bottom: 0.5rem;
  pointer-events: none;
  position: relative;
  &:after {
    animation: pulse-opacity 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    border-radius: 0.25rem;
    position absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 0.875rem;
    transform: translate(-50%, -50%);
    content: '';
    display: block;
    background-color: var(--gray-200);
  }
`;

export const SkeletonDetailsIcon = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--gray-200);
  animation: pulse-opacity 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

export const SkeletonDetailsText = styled.div`
  font-family: ${({ theme }) => theme.font.body};
  font-size: 0.875rem;
  min-width: 3.438rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
  color: transparent;
  position: relative;
  &:after {
    animation: pulse-opacity 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    border-radius: 0.25rem;
    position absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 0.75rem;
    transform: translate(-50%, -50%);
    content: '';
    display: block;
    background-color: var(--gray-200);
  }
`;

export const FormattedPriceSkeleton = styled.span`
  color: transparent;
  font-family: ${({ theme }) => theme.font.body};
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.875rem;
  position: relative;
  width: 5.875rem;
  &:after {
    animation: pulse-opacity 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    border-radius: 0.25rem;
    position absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 1.125rem;
    transform: translate(-50%, -50%);
    content: '';
    display: block;
    background-color: var(--gray-200);
  }
`;

export const SkeletonAvailabiltyStatus = styled.div`
  color: transparent;
  text-align: right;
  font-family: ${({ theme }) => theme.font.body};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.25rem;
  white-space: nowrap;
  width: 6.313rem;
  position: relative;
  &:after {
    animation: pulse-opacity 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    border-radius: 0.25rem;
    position absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 0.75rem;
    transform: translate(-50%, -50%);
    content: '';
    display: block;
    background-color: var(--gray-200);
  }

`;
